var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 9.75C2.25 5.60786 5.60786 2.25 9.75 2.25C13.8921 2.25 17.25 5.60786 17.25 9.75C17.25 13.8921 13.8921 17.25 9.75 17.25C5.60786 17.25 2.25 13.8921 2.25 9.75ZM9.75 0.75C4.77944 0.75 0.75 4.77944 0.75 9.75C0.75 14.7206 4.77944 18.75 9.75 18.75C11.9653 18.75 13.9936 17.9496 15.5616 16.6223L21.9697 23.0304C22.2626 23.3232 22.7374 23.3232 23.0303 23.0304C23.3232 22.7375 23.3232 22.2626 23.0303 21.9697L16.6223 15.5616C17.9496 13.9936 18.75 11.9653 18.75 9.75C18.75 4.77944 14.7206 0.75 9.75 0.75Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search.8e81e60e8943fc2871fb7cb9a6c5c011.svg";